import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

import { CacheService  } from '../core/cache.service';
import { ApiService  } from '../core/api.service';
import { Mappings} from '../../shared/mapping';
import { Menu } from "./../../models/cms/menu";

@Injectable()
export class CmsMenuListService 
{
    constructor
    (
        public _api: ApiService, 
        public _cache: CacheService,
        private mappings: Mappings
    ) {}

    private setPageUrl(menus) 
    {
        for (let index in menus) 
        {
            if (menus[index].SeoUrl != undefined &&
                menus[index].SeoUrl != null &&
                menus[index].SeoUrl != "") {
                menus[index].Url = "/" + menus[index].SeoUrl;
            } 
            else 
            {
                menus[index].Url = '/cms/' + menus[index].Id;
            }

            if (menus[index].Children !== undefined && menus[index].Children.length > 0) 
            {
                this.setPageUrl(menus[index].Children);
            }
        }
    }

    LoadData(pageId: string, lang: string) 
    {
        let url =  this.mappings.Web_Api_Get_Cms_Menu_List
        .replace('{id}',pageId)
        .replace('{lang}',lang);
        let key = url;

        return this._api.get(url)
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/cms/cms-menu-list.service.ts